import { Datepicker } from 'stimulus-datepicker';

export default class extends Datepicker {
  static values = {
    ...Datepicker.values,
    min: String,
  };

  connect() {
    super.connect();
    this.normalizeTwoDigitYear();
  }

  disconnect() {
    // Clean up event listener to prevent memory leaks
    if (this.handleBlur) {
      const input = this.inputTarget;
      if (input) {
        input.removeEventListener('blur', this.handleBlur);
      }
    }
    super.disconnect();
  }

  // Normalize 2-digit years to 4-digit years when user manually enters dates
  normalizeTwoDigitYear() {
    const input = this.inputTarget;
    if (!input) return;

    // Store handler reference for cleanup
    this.handleBlur = (e) => {
      const value = e.target.value.trim();

      // Skip if empty or already has 4-digit year
      if (!value || /\d{4}/.test(value)) {
        return;
      }

      // Match dates in format M/D/YY, MM/DD/YY, M-D-YY, or MM-DD-YY (with or without leading zeros)
      // Accepts both slashes and dashes as separators (dash at end of character class is safer)
      const twoDigitYearPattern = /^(\d{1,2})[\/-](\d{1,2})[\/-](\d{2})$/;
      const match = value.match(twoDigitYearPattern);

      if (match) {
        const month = parseInt(match[1], 10);
        const day = parseInt(match[2], 10);
        const twoDigitYear = parseInt(match[3], 10);

        // Validate month and day are in valid ranges
        if (month < 1 || month > 12 || day < 1 || day > 31) {
          return; // Invalid date, let datepicker handle the error
        }

        // Convert 2-digit year to 4-digit year
        // Years 00-30 are assumed to be 2000-2030, years 31-99 are 1931-1999
        const fourDigitYear =
          twoDigitYear <= 30 ? 2000 + twoDigitYear : 1900 + twoDigitYear;

        // Format according to %-m/%-d/%Y (no leading zeros for month/day, always use slashes)
        const normalizedValue = `${month}/${day}/${fourDigitYear}`;

        // Only update if the value actually changed
        if (value !== normalizedValue) {
          e.target.value = normalizedValue;

          // Trigger input event to let datepicker re-parse the value
          // Use a small timeout to ensure datepicker's blur handler runs first
          setTimeout(() => {
            e.target.dispatchEvent(new Event('input', { bubbles: true }));
          }, 0);
        }
      }
    };

    input.addEventListener('blur', this.handleBlur);
  }

  // No need to override format as a getter - it's handled by the values system
  // The format can be set via data-datepicker-format-value in HTML
  // Default format is %Y-%m-%d which gives you yyyy-mm-dd
}
